import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { SnotifyService } from 'ng-snotify';
import { FillBatchHeader } from '../models/fill_batch_header';
import * as moment from 'moment';

@Injectable()
export class FillBatchReportService {
  constructor(private http: HttpClient, private authService: AuthService, private snotifyService: SnotifyService) { }

  public getResults(page: Page, batch_Num: string, start_Date: string, end_Date: string, quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Fill_Date_Sorting'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&batch_Num=' + batch_Num;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'FillBatchReport/GetTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log("Data Retrieved")
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getBatchCylResults(page: Page, fill_Batch_Id: number, rejectCheck: boolean, quick_Search: string): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Cyl_Serial_Num'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&fill_Batch_Id=' + fill_Batch_Id;
      params += '&reject=' + rejectCheck;
      params += '&quick_Search=' + quick_Search;

      this.http.get<ServerData>(environment.apiUrl + 'FillBatchReport/GetBatchCylTable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;
        console.log("Data Retrieved")
        console.log(data);
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public getHeadlineDetails(fill_Batch_Id: number): Promise<any> {
    const headlineDetails = new Array();

    return new Promise((resolve, reject) => {

      let params = '?fill_Batch_Id=' + fill_Batch_Id;

      this.http.get<ServerData>(environment.apiUrl + 'FillBatchReport/GetHeadlineDetails' + params).subscribe(data => {

        console.log("Data Retrieved")
        console.log(data);

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          headlineDetails.push(jsonObj);
        }

        resolve(headlineDetails);

      }, error => {
        reject();
      });
    });
  }

  public getFillPressures(): Promise<any> {
    const fillPressure = new Array();

    return new Promise((resolve, reject) => {

      this.http.get<ServerData>(environment.apiUrl + 'FillBatchReport/GetFillPressures').subscribe(data => {

        console.log("Data Retrieved")
        console.log(data);

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          fillPressure.push(jsonObj);
        }

        resolve(fillPressure);

      }, error => {
        reject();
      });
    });
  }

  public updateFillBatchDetails(fillBatchHeader: FillBatchHeader): Promise<FillBatchHeader> {

    fillBatchHeader.expiry_Date.setHours(12);
    fillBatchHeader.fill_Date.setHours(12);
    console.log(fillBatchHeader);
    console.log(environment.apiUrl + 'FillBatchReport/UpdateFillBatchDetails');

    return new Promise((resolve, reject) => {
      this.http.post<FillBatchHeader>(environment.apiUrl + 'FillBatchReport/UpdateFillBatchDetails', fillBatchHeader).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully Updated Batch Details');
      }, error => {
        this.snotifyService.success('Failed to Update Batch Details: ' + error);
        console.log(error);
        reject();
      });
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }

  public getExcel(batch_Num: string, start_Date: string, end_Date: string): Promise<any> {

    return new Promise((resolve, reject) => {

      let params = '?batch_Num=' + batch_Num;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');

      this.http.get<any>(environment.apiUrl + 'FillBatchReport/GetExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getBatchCylExcel(page: Page, fill_Batch_Id: number, rejectCheck: boolean, quick_Search: string): Promise<any> {

    return new Promise((resolve, reject) => {

      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Cyl_Serial_Num'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '?fill_Batch_Id=' + fill_Batch_Id;
      params += '&reject=' + rejectCheck;
      params += '&sortBy=' + page.sortBy;
      params += '&sortOrder=' + page.sortOrder;
      params += '&quick_Search=' + quick_Search;

      this.http.get<any>(environment.apiUrl + 'FillBatchReport/GetBatchCylExcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
